// Display labels that differ from the stored value. Assignments are "ended" (a project is
// what gets "completed"); the DB keeps `completed` so nothing downstream changes.
const LABELS = { assignment: { completed: "ENDED", ended: "ENDED" } };

export function StatusPill({ status, kind }) {
  const key = (status || "draft").toLowerCase();
  const label = (LABELS[kind] || {})[key] || (status || "").replace(/_/g, " ").toUpperCase();
  return (
    <span data-testid={`status-pill-${key}`} className={`pill pill-${key}`}>
      {label}
    </span>
  );
}
